import * as React from 'react';
import { ExperimentControl, Experiment, ExperimentVariant } from '@shared-ui/experiment-context';
import { GlobalNavigationLineOfBusiness } from '@shared-ui/global-navigation-header';
import { SiteHeader as GlobalNavigationSiteHeader } from '../../global-navigation/header/site-header';
import { CustomerNotifications } from '../customer-notifications';
export var SharedUIHeaderLineOfBusiness = React.createContext(GlobalNavigationLineOfBusiness.UNKNOWN);
export var SharedUIHeaderMarketing = React.createContext(null);
export var Header = function (_a) {
  var className = _a.className,
    minimal = _a.minimal,
    lineOfBusiness = _a.lineOfBusiness,
    customJourneyCriterias = _a.customJourneyCriterias,
    marketing = _a.marketing,
    fullWidth = _a.fullWidth,
    pageName = _a.pageName;
  return React.createElement(SharedUIHeaderLineOfBusiness.Provider, {
    value: lineOfBusiness
  }, React.createElement(SharedUIHeaderMarketing.Provider, {
    value: marketing
  }, React.createElement("div", {
    className: "page-header ".concat(className || '')
  }, React.createElement(CustomerNotifications, {
    key: "customer-notifications-pre-header",
    location: "PRE_HEADER",
    journeyCriterias: customJourneyCriterias
  }), React.createElement(CustomerNotifications, {
    key: "customer-notifications-legal",
    location: "LEGAL"
  }), React.createElement(Experiment, {
    name: "GN_Simplified_Header"
  }, React.createElement(ExperimentControl, null, React.createElement(GlobalNavigationSiteHeader, {
    minimal: minimal,
    fullWidth: fullWidth,
    simplified: true,
    pageName: pageName
  })), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(GlobalNavigationSiteHeader, {
    minimal: minimal,
    pageName: pageName
  }))))));
};